export const ReaderEvent = {
  SetPageIndexEvent: 'SetPageIndexEvent',
  setFullVideoEvent: 'setFullVideoEvent',
  setFullScreenTargetEvent: 'setFullScreenTargetEvent',
  sendFullVideoEvent: 'sendFullVideoEvent',
  ClickNextPageEvent: 'ClickNextPageEvent',
  ClickPreviousPageEvent: 'ClickPreviousPageEvent',
  ClickBookThumbnailEvent: 'ClickBookThumbnailEvent',
  RefreshCanvasEvent: 'RefreshCanvasEvent',
  CreateAndEnterAnnotationEvent: 'CreateAndEnterAnnotationEvent',
  ClickBookmarkEvent: 'ClickBookmarkEvent',
  AreaZoomEvent: 'AreaZoomEvent',
  SetAreaZoomIntoEvent: 'SetAreaZoomIntoEvent',
  AreaZoomForPageButtonEvent: 'AreaZoomForPageButtonEvent',
  DrawAreaEvent: 'DrawAreaEvent',
  GoBackCatalogEvent: 'GoBackCatalogEvent',
  SaveAnnotationNameEvent: 'SaveAnnotationNameEvent',
  DeleteAnnotationEvent: 'DeleteAnnotationEvent',
  CopyAnnotationEvent: 'CopyAnnotationEvent',
  GetLocalAnnotationEvent: 'GetLocalAnnotationEvent',
  ClickCanvasSVGObjectEvent: 'ClickCanvasSVGObjectEvent',
  ResetReaderStateEvent: 'ResetReaderStateEvent',
  ExecuteCanvasSVGCommandEvent: 'ExecuteCanvasSVGCommandEvent',
  SaveCanvasSVGObjectEvent: 'SaveCanvasSVGObjectEvent',
  DeleteCanvasSVGObjectInfoEvent: 'DeleteCanvasSVGObjectInfoEvent',
  SetCanvasSVGObjectIdEvent: 'SetCanvasSVGObjectIdEvent',
};

export const ReaderToolsEvent = {
  SetReaderToolsEvent: 'SetReaderToolsEvent',
  SetReaderToolHeight: 'SetReaderToolHeight',
  TogglePageModeEvent: 'TogglePageModeEvent',
  ToggleBookmarkEvent: 'ToggleBookmarkEvent',
  ClickDragEvent: 'ClickDragEvent',
  ReimportSVGEvent: 'ReimportSVGEvent',
  ClickSelectEvent: 'ClickSelectEvent',
  SVGCanvasSwitchEvent: 'SVGCanvasSwitchEvent',
  DrawSVGCanvasSwitchEvent: 'DrawSVGCanvasSwitchEvent',
  ClickPainterEvent: 'ClickPainterEvent',
  ClickEraserEvent: 'ClickEraserEvent',
  ClickInsertImageEvent: 'ClickInsertImageEvent',
  ClickInsertTextEvent: 'ClickInsertTextEvent',
  ToggleSideBarEvent: 'ToggleSideBarEvent',
  TogglePageSearcherEvent: 'TogglePageSearcherEvent',
  ClickReaderOptionPanelEvent: 'ClickReaderOptionPanelEvent',
  ClickStampPanelEvent: 'ClickStampPanelEvent',
  ClickOpenActivityEvent: 'ClickOpenActivityEvent',
  SetObjectPropertyEvent: 'SetObjectPropertyEvent',
  ChangeReaderToolStyleEvent: 'ChangeReaderToolStyleEvent',
  ChangeReaderToolDirectionEvent: 'ChangeReaderToolDirectionEvent',
  ChangeStampStatusEvent: 'ChangeStampStatusEvent',
  OnMarkModeEvent: 'OnMarkModeEvent',
  SelectMarkEvent: 'SelectMarkEvent',
  SaveMarkEvent: 'SaveMarkEvent',
  SetMarkToolsEnableEvent: 'SetMarkToolsEnableEvent',
  ClickEraseAllEvent: 'ClickEraseAllEvent',
  SetReaderZoomEvent: 'SetReaderZoomEvent',
  ZoomToolEvent: 'ZoomToolEvent',
  SetRemoteZoomInfoEventHandler: 'SetRemoteZoomInfoEventHandler',
  ClickFullWidthEvent: 'ClickFullWidthEvent',
  SaveReaderToolSettingsEvent: 'SaveReaderToolSettingsEvent',
  BackToCatalogEvent: 'BackToCatalogEvent',
  SetReaderToolTypeEvent: 'SetReaderToolTypeEvent',
  ChangePopWindowScaleEvent: 'ChangePopWindowScaleEvent',
  ChangePopWindowFontSizeEvent: 'ChangePopWindowFontSizeEvent',
  ClickOfflineReaderToolBoxEvent: 'ClickOfflineReaderToolBoxEvent',
  SetObjectPointerStatusEvent: 'SetObjectPointerStatusEvent',
  ClickMathToolsEvent: 'ClickMathToolsEvent',
  ClickReaderToolBoxEvent: 'ClickReaderToolBoxEvent',
  CreateCourseInteractiveItemEvent: 'CreateCourseInteractiveItemEvent',
  SendExpressionEvent: 'SendExpressionEvent',
  SetSaveCanvasJsonTimeEvent: 'SetSaveCanvasJsonTimeEvent',
  SetRewardInfoEvent: 'SetRewardInfoEvent',
  PlayExpression: 'PlayExpression',
  CloseModalEvent: 'CloseModalEvent',
  ResetCourseAnnotationEvent: 'ResetCourseAnnotationEvent',
};

export const PainterEvent = {
  ChangeBrushColorEvent: 'ChangeBrushColorEvent',
  ChangeBrushWidthEvent: 'ChangeBrushWidthEvent',
  ChangeBrushTypeEvent: 'ChangeBrushTypeEvent',
  ChangePainterTypeEvent: 'ChangePainterTypeEvent',
  ChangeShapeFillTypeEvent: 'ChangeShapeFillTypeEvent',
  ChangelineTypeEvent: 'ChangelineTypeEvent'
};

export const CanvasEvent = {
  CanvasTextCreatedEvent: 'CanvasTextCreatedEvent',
  CanvasTextChangedEvent: 'CanvasTextChangedEvent',
  CanvasChooseImageSourceEvent: 'CanvasChooseImageSourceEvent',
  CanvasFinishPaintingEvent: 'CanvasFinishPaintingEvent',
  CanvasImportJSONEvent: 'CanvasImportJSONEvent',
  CanvasObjectSelectedEvent: 'CanvasObjectSelectedEvent',
  CanvasTextObjectSelectedEvent: 'CanvasTextObjectSelectedEvent',
  CanvasSelectionClearEvent: 'CanvasSelectionClearEvent',
  CanvasImageCreatedEvent: 'CanvasImageCreatedEvent',
  CanvasStampCreatedEventEvent: 'CanvasStampCreatedEventEvent',
  CreatedCanvasObjectEvent: 'CreatedCanvasObjectEvent',
  ModifyCanvasObjectPropertyEvent: 'ModifyCanvasObjectPropertyEvent',
  RemoveCanvasObjectEvent: 'RemoveCanvasObjectEvent',
  SetCanvasLevelEvent: 'SetCanvasLevelEvent',
  SetCanvasShadowEvent: 'SetCanvasShadowEvent',
  FlipCanvasEvent: 'FlipCanvasEvent',
  AlignCanvasGroupEvent: 'AlignCanvasGroupEvent',
  CanvasSavedEvent: 'CanvasSavedEvent',
  CanvasCloseMode: 'CanvasCloseMode',
  CanvasObjectCopyEvent: 'CanvasObjectCopyEvent',
  ToggleCanvasGroupEvent: 'ToggleCanvasGroupEvent',
  LockCanvasObjectEvent: 'LockCanvasObjectEvent',
  AdjustCanvasLineAngleEvent: 'AdjustCanvasLineAngleEvent',
  SendCanvasSVGObjectAnnotationEvent: 'SendCanvasSVGObjectAnnotationEvent',
};

export const UserEvent = {
  LoginEvent: 'LoginEvent',
  GetUserIdentityEvent: 'GetUserIdentityEvent'
};

export const ActivityEvent = {
  CreatActivityEvent: 'CreatActivityEvent',
  EnterActivityEvent: 'EnterActivityEvent',
  ChangeActivityTargetEvent: 'ChangeActivityTargetEvent',
  JoinActivityEvent: 'JoinActivityEvent',
  SendActivityInfoToFirebaseEvent: 'SendActivityInfoToFirebaseEvent',
  // GetActivityEvent: 'GetActivityEvent',
  OnAnnotationUpdateEvent: 'OnAnnotationUpdateEvent',
  UpdateActivityInfo: 'UpdateActivityInfo',
  LeaveActivityEvent: 'LeaveActivityEvent',
  ToggleActivityPanelEvent: 'ToggleActivityPanelEvent'
};

export const InteractiveObjectEvent = {
  ClickInteractiveObjectEvent: 'ClickInteractiveObjectEvent',
  ExportInteractiveObjectEvent: 'ExportInteractiveObjectEvent',
  SetInteractiveObjectStateEvent: 'SetInteractiveObjectStateEvent'
};


export const ExtendedContentEvent = {
  SetWordLearningGridPlaybackRateEvent: 'SetWordLearningGridPlaybackRateEvent',
};

export const EmojiEvent = {
  AddUpEmojiEvent: 'AddUpEmojiEvent'
};
export const ToolsEvent = {
  ToolsIsControl: 'ToolsIsControl'
};
